import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import Admin from "../views/Admin.vue";
import Login from "../views/Login.vue";

const routes = [
  { path: "/", component: Home },
  { path: "/login", component: Login },
  { path: "/admin", component: Admin },
  {
    path: "/galerie",
    name: "Gallery",
    component: () => import("@/components/Gallery.vue"),
  },
  {
    path: "/despre-noi",
    name: "DespreNoi",
    component: () => import("@/components/DespreNoi.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("@/components/Contact.vue"),
  },
  {
    path: "/detailing",
    name: "Detailing",
    component: () => import("@/views/servicii/Detailing.vue"),
  },
  {
    path: "/polish",
    name: "Polish",
    component: () => import("@/views/servicii/Polish.vue"),
  },

  {
    path: "/folii-solare",
    name: "FoliiSolare",
    component: () => import("@/views/servicii/FoliiSolare.vue"),
  },
  {
    path: "/colantare",
    name: "Colantare",
    component: () => import("@/views/servicii/Colantare.vue"),
  },
  {
    path: "/ppf",
    name: "PPF",
    component: () => import("@/views/servicii/PPF.vue"),
  },
  {
    path: "/lumini-ambientale",
    name: "LuminiAmbientale",
    component: () => import("@/views/servicii/LuminiAmbientale.vue"),
  },
  {
    path: "/trape-panoramice",
    name: "TrapePanoramice",
    component: () => import("@/views/servicii/TrapePanoramice.vue"),
  },
  {
    path: "/retapitari",
    name: "Retapitari",
    component: () => import("@/views/servicii/Retapitari.vue"),
  },
  {
    path: "/vopsire-piele",
    name: "VopsirePiele",
    component: () => import("@/views/servicii/VopsirePiele.vue"),
  },
  {
    path: "/mecanica",
    name: "Mentenanta",
    component: () => import("@/views/servicii/Mentenanta.vue"),
  },
  {
    path: "/politica-confidentialitate",
    component: () => import("@/components/PoliticaConfidentialitate.vue"),
  },
  {
    path: "/politica-cookie",
    component: () => import("@/components/PoliticaCookie.vue"),
  },
  {
    path: "/anpc",
    component: () => import("@/components/ANPC.vue"),
  },
];
// ===== SEO (Title + Description + Canonical) =====
const BASE = "https://autoheaven.ro";

const SEO = {
  "/": {
    title: "AutoHeaven Giarmata – Detailing auto Timișoara și împrejurimi",
    desc: "Detailing, polish, PPF, colantare, folii solare și servicii premium în zona Timișoara – Giarmata. Programări rapide.",
  },
  "/contact": {
    title: "Contact AutoHeaven – Programări (Giarmata / Timișoara)",
    desc: "Contact AutoHeaven pentru programări: detailing, polish, trape panoramice și alte servicii. Giarmata, Timișoara și împrejurimi.",
  },

  // TOP 3 ale tale:
  "/detailing": {
    title: "Detailing auto Timișoara (Giarmata) | AutoHeaven",
    desc: "Detailing interior/exterior, curățare profesională și protecții. AutoHeaven în Giarmata – Timișoara și împrejurimi. Programare rapidă.",
  },
  "/polish": {
    title: "Polish auto Timișoara (Giarmata) | Corecție lac | AutoHeaven",
    desc: "Polish profesional, corecție zgârieturi fine, luciu și protecție. AutoHeaven Giarmata – Timișoara și împrejurimi.",
  },
  "/trape-panoramice": {
    title:
      "Trape panoramice Timișoara (Giarmata) | Reparații & etanșări | AutoHeaven",
    desc: "Reparații, etanșări și întreținere trape/panoramice. AutoHeaven Giarmata – Timișoara și împrejurimi. Programare rapidă.",
  },

  // Restul serviciilor (bonus, că tot le ai în meniu)
  "/folii-solare": {
    title: "Folii solare auto Timișoara (Giarmata) | Tinting | AutoHeaven",
    desc: "Montaj folii solare omologate, estetică și protecție UV. AutoHeaven Giarmata – Timișoara și împrejurimi.",
  },
  "/colantare": {
    title: "Colantare auto Timișoara (Giarmata) | Wrapping | AutoHeaven",
    desc: "Colantare / wrapping auto: elemente sau integral. Finisaje premium. AutoHeaven Giarmata – Timișoara și împrejurimi.",
  },
  "/ppf": {
    title: "PPF Timișoara (Giarmata) | Protecție folie PPF | AutoHeaven",
    desc: "Folie PPF pentru protecția vopselei: zone cheie sau pachete. AutoHeaven Giarmata – Timișoara și împrejurimi.",
  },
  "/lumini-ambientale": {
    title: "Lumini ambientale auto Timișoara (Giarmata) | AutoHeaven",
    desc: "Montaj lumini ambientale auto cu finisaj curat și integrare profesionistă. AutoHeaven Giarmata – Timișoara și împrejurimi.",
  },
  "/retapitari": {
    title: "Retapițări auto Timișoara (Giarmata) | AutoHeaven",
    desc: "Retapițări și recondiționări interior auto. AutoHeaven Giarmata – Timișoara și împrejurimi.",
  },
  "/vopsire-piele": {
    title: "Vopsire piele auto Timișoara (Giarmata) | AutoHeaven",
    desc: "Vopsire și recondiționare piele: scaune, volan, elemente interior. AutoHeaven Giarmata – Timișoara și împrejurimi.",
  },
  "/mecanica": {
    title:
      "Mentenanță și revizii auto periodice Timișoara (Giarmata) | AutoHeaven",
    desc: "Revizii auto periodice, schimb ulei și filtre, verificări tehnice și resetare interval service. AutoHeaven Giarmata – Timișoara și împrejurimi.",
  },
  "/galerie": {
    title: "Galerie AutoHeaven – Before/After | Timișoara (Giarmata)",
    desc: "Galerie foto AutoHeaven: rezultate înainte/după pentru detailing, polish, colantare și alte servicii. Timișoara – Giarmata.",
  },
  "/despre-noi": {
    title: "Despre AutoHeaven – Detailing premium în Timișoara (Giarmata)",
    desc: "AutoHeaven – servicii premium pentru mașina ta: detailing, polish, PPF, colantare și multe altele. Lucrăm în zona Timișoara – Giarmata.",
  },
  "/politica-confidentialitate": {
    title: "Politica de confidențialitate | AutoHeaven",
    desc: "Politica de confidențialitate AutoHeaven – informații despre datele colectate și modul de utilizare.",
  },
  "/politica-cookie": {
    title: "Politica de cookie | AutoHeaven",
    desc: "Politica de cookie AutoHeaven – cum folosim cookie-urile și cum poți gestiona preferințele.",
  },
  "/anpc": {
    title: "ANPC | AutoHeaven",
    desc: "Informații ANPC și detalii utile pentru clienți.",
  },
};

function setMetaDescription(content) {
  let tag = document.querySelector('meta[name="description"]');
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", "description");
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content || "");
}

function setCanonical(href) {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}

// ✅ 1. Creezi routerul
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

// ✅ 2. Protecție pentru ruta /admin
router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  const hasToken = !!localStorage.getItem("adminToken");

  // dacă utilizatorul nu e logat și încearcă să intre la /admin → redirect la /login
  if (to.path === "/admin" && (!isLoggedIn || !hasToken)) {
    next("/login");
  } else if (to.path === "/login" && isLoggedIn && hasToken) {
    // dacă e deja logat și merge la login → du-l direct la admin
    next("/admin");
  } else {
    next();
  }
});

// ✅ 3. Deblochează body după orice navigare (dacă rămâne blocat de la lightbox/overlay)
router.afterEach((to) => {
  // 1) Deblochează body (cum aveai)
  document.body.style.overflow = "";

  // 2) SEO
  const seo = SEO[to.path] || SEO["/"];
  if (seo) {
    document.title = seo.title;
    setMetaDescription(seo.desc);
    setCanonical(`${BASE}${to.path}`);
  }
});

// ✅ 4. Export router
export default router;
